import React, { Component } from "react";
import { Icon, Segment } from "semantic-ui-react";
import ReactTable from "react-table";
import ReportFilters from "../../components/reports/ReportFilters";
import PageHeader from "../../components/PageHeader";
import _ from 'lodash';
import request from "../../utils/request";
import moment from "moment"

const reportOptions = [
  {
    value: "/report/event-details",
    text: "Event Details",
  },
  {
    value: "/report/payments",
    text: "Payments",
  },
  {
    value: "/report/payments-debit-void",
    text: "Payments Debit Voided",
  },
  {
    value: "/report/tickets",
    text: "Tickets",
  },
  {
    value: "/report/payment-jurisdiction",
    text: "Payment Jurisdiction",
  },
  {
    value: "/report/payment-tickets",
    text: "Payment Tickets",
  },
  {
    value: "/report/ticket-exception",
    text: "Ticket Exception"
  },
  {
    value: "/report/sellers",
    text: "Sellers"
  },
  {
    value: "/report/sales-per-hour",
    text: "Sales Per Hour"
  },
  {
    value: "/report/customers",
    text: "Customers"
  },
  {
    value: "/report/customer-spend-annual",
    text: "Customer Spend Per Annum"
  },
  {
    value: "/report/customer-purchases",
    text: "Customer Purchases"
  },
  {
    value: "/report/ticket-block-dump",
    text: "Ticket Block Dump"
  },
  {
    value: "/report/ticket-blocks",
    text: "Ticket Blocks"
  },
  {
    value: "/report/price-points",
    text: "Price Points"
  },
  {
    value: "/report/price-point-event-seller",
    text: "Price Point By Event Seller",
  },
  {
    value: "/report/drum-log",
    text: "Drum Log"
  },
  {
    value: "/report/event-log",
    text: "Event Log"
  },
  {
    value: "/report/cash-drop",
    text: "Cash Drops"
  },
  {
    value: "/report/web-sales",
    text: "Web Sales"
  },
  {
    value: "/report/web-sales-exception",
    text: "Web Sales Exceptions"
  },
  {
    value: "/report/winners",
    text: "Winners"
  },
  {
    value: "/report/recipient",
    text: "Web Sales Recipients"
  },
  {
    value: "/report/beneficiary-jurisdiction",
    text: "Beneficiary Jurisdiction",
  },
  {
    value: "/report/beneficiary",
    text: "Beneficiary"
  },
  {
    value: "/report/audit",
    text: "Audit"
  },
  {
    value: "/report/raffle-draws",
    text: "Raffle Draws"
  },
  {
    value: "/report/early-bird-draws",
    text: "Early Bird Draws"
  },
  {
    value: "/report/version-history",
    text: "Version History"
  },
  {
    value: "/report/locations",
    text: "Locations"
  },
  {
    value: "/report/subscriptions",
    text: "Active Subscriptions"
  },
  {
    value: "/report/cancelled-subscriptions",
    text: "Cancelled Subscriptions"
  }
];
const salesBreakdown = [
  {
    Header: "Price Point",
    id: "amount",
    accessor: d => d.quantity + " for " + d.amount
  },
  {
    Header: "Count",
    accessor: "total_sets"
  },
  {
    Header: "Total Numbers",
    accessor: "total_tickets"
  },
  {
    Header: "Total Cost",
    accessor: "total_cost"
  },
  {
    Header: "% of Sales",
    accessor: "sales_pc"
  },
  {
    Header: "% of Tickets",
    accessor: "tickets_pc"
  }
];

const locationSalesBreakdown = [
  { Header: "Time Duration In Minute", accessor: "time_duration" },
  { Header: "Time Frames", accessor: "time_frames" },
  { Header: "Sector Name", accessor: "sector_name" },
  { Header: "Total Cost", accessor: "total_cost" },
  { Header: "Total Quantity", accessor: "quantity" },
  { Header: "Total Tickets", accessor: "amount" }
];

const CustomerData = [
  { Header: "first_name", accessor: "first_name" },
  { Header: "last_name", accessor: "last_name" },
  { Header: "email", accessor: "email" },
  { Header: "address", accessor: "address" },
  { Header: "city", accessor: "city" },
  { Header: "state", accessor: "state" },
  { Header: "zip_code", accessor: "zip_code" },
  { Header: "phone", accessor: "phone" },
  { Header: "phone_work", accessor: "phone_work" },
  { Header: "phone_home", accessor: "phone_home" },
  { Header: "subscribe_email", accessor: "subscribe_email" },
  { Header: "subscribe_text", accessor: "subscribe_text" },
  { Header: "age_range", accessor: "age_range" }
];
const volunteerBreakdownColumn = [
  { Header: "Seller", accessor: "volunteer_name" },
  { Header: "Total Sales", accessor: "total_sales" },
  { Header: "Total Count", accessor: "total_transactions_count" },
  { Header: "Total Credit Sales", accessor: "total_credit_sales" },
  { Header: "Total Cash Sales", accessor: "total_cash_sales" },
  { Header: "Total Debit Sales", accessor: "total_debit_sales" },
  { Header: "Total Cash Count", accessor: "total_cash_count" },
  { Header: "Total Debit Count", accessor: "total_debit_count" },
  { Header: "Total Credit Count", accessor: "total_credit_count" },
  { Header: "Total Duration In Minute", accessor: "duration_in_minutes" },
  { Header: "Time Frames", accessor: "time_frames" },
];
class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isMounted: false,
      apiEndpoint: null,
      eventOptions: [],
      eventIds: [],
      reportOptions: reportOptions,
      startAt: "",
      endAt: "",
      datesRange: "",
      pageSize: 100,
      page: 0,
      pages: -1,
      sorted: [],
      filtered: [],
      columns: [],
      data: [],
      error: null
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.sortReportOptionsByalphabetOrder(reportOptions);
    this.fetchEvents();
  };

  fetchEvents = resp => {
    if (!resp) {
      this.setState({ isLoading: true });
      return request.list(
        this,
        "api:/event",
        {
          limit: 1000,
          sort: [{ id: "start_at", desc: true }],
          filter_draws: 4
        },
        this.fetchEvents
      );
    }
    let events = [];
    resp.data.map((value) => {
      if (value.is_test !== 1) {
        return events.push({
          text: value.title,
          value: parseInt(value.id)
        });
      }
    });
    this.setState({ isLoading: false, eventOptions: events });
    return true;
  };

  sortReportOptionsByalphabetOrder = reportOptions => {
    reportOptions.sort(function(a, b) {
      var reportA = a.text.toUpperCase();
      var reportB = b.text.toUpperCase();
      return (reportA < reportB) ? -1 : (reportA > reportB) ? 1 : 0;
    });
  };

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
    if (name == "apiEndpoint" && value != this.state.apiEndpoint) {
      this.setState({
        sorted: [],
        filtered: [],
      });
    }
    let startStr = this.state.startAt ? this.state.startAt : moment(0).format("YYYY-MM-DD HH:mm:ss");
    let endStr = this.state.endAt ? this.state.endAt : moment().format("YYYY-MM-DD HH:mm:ss");

    let dateRangeStr = this.state.startAt == "" && this.state.endAt === "" ? "" : startStr +' to '+ endStr;
    this.setState({ datesRange: dateRangeStr });
  }

  fetchData = () => {
    if (this.state.apiEndpoint === null) {
      this.setState({ isLoading: false });
      return;
    }
    if (this.state.eventIds.length === 0) {
      this.setState({ isLoading: false, error: 'Please select at least one event.' });
      return;
    }
    this.setState({ isLoading: true, error: null });

    let payload = {
      event_ids: this.state.eventIds,
      date_range: this.state.datesRange,
      page_size: this.state.pageSize,
      page: this.state.page + 1,
      sorted: this.state.sorted,
      filtered: this.state.filtered,
      export: 0
    };
    return request.post(this, this.state.apiEndpoint, payload)
      .then(resp => {
        this.handleData(resp);
       });
  };

  handleData = resp => {
    this.setState({
      isLoading: false
    });
    if (resp.data) {

      let columns = [];
      columns.push({
        expander: true,
        show:
          resp.data.length > 0 &&
          (typeof resp.data[0].sales !== "undefined" ||
            typeof resp.data[0].volunteer_breakdown !== "undefined" ||
            typeof resp.data[0].CustomerData !== "undefined"),
        Header: () => <strong>More</strong>,
        Footer: () => '',
        width: 65,
        Expander: ({ isExpanded, ...rest }) => (
          <div>
            {isExpanded ? (
              <Icon name="caret down" />
            ) : (
              <Icon name="caret right" />
            )}
          </div>
        ),
        style: {
          cursor: "pointer",
          fontSize: 25,
          padding: "0",
          textAlign: "center",
          userSelect: "none"
        }
      });

      for (let key in resp.headers) {
        if (key === 'gifted__recipients') {

          columns.push({
            Header: resp.headers[key],
            accessor: key,
            width: 250, // set this column statically since the string is html
            Cell: row => (
              <span>
                < div dangerouslySetInnerHTML={{
                  __html: row.value
                }}
                />
              </span>
            ),
            Footer: (resp.recordsAggregate && resp.recordsAggregate[key]) ? resp.recordsAggregate[key].toString() : ''
          });
        } else {
          columns.push({
            Header: resp.headers[key],
            accessor: key,
            width: this.getColumnWidth(resp.data, key, resp.headers[key]),
            minWidth: 90,
            sortable: key.includes('--not_able_to_sortable') ? false : true,
            Footer: (resp.recordsAggregate && resp.recordsAggregate[key]) ? resp.recordsAggregate[key].toString() : ''
          });
        }
      }

      this.setState({
        data: resp.data,
        columns: columns,
        pages: resp.last_page,// Math.ceil(resp.total / this.state.pageSize)
      });
    }
  };

  getColumnWidth = (data, accessor, headerText) => {
    const cellLength = Math.max(
      ...data.map(row => {
        let value = '';
        if (typeof accessor === 'string') {
          value = _.get(row, accessor);
        } else {
          value = accessor(row);
        }
        if (typeof value === 'number') {
          return this.getTextWidth(value.toString());
        }
        return this.getTextWidth(value);
      }),
      this.getTextWidth(headerText)
    );
    const magicSpacing = 30;
    let ret = cellLength + magicSpacing;
    return ret < 60 ? 60 : ret;
  };

  getTextWidth = (text, font = "bold 12pt arial") => {
    // re-use canvas object for better performance
    var canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement("canvas"));
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
  };

  fetchExport = req => {
    if (this.state.eventIds.length === 0 && this.state.datesRange === "") {
      this.setState({ isLoading: false });
      return;
    }
    this.setState({
      isLoading: true
    });
    let payload = {
      event_ids: this.state.eventIds,
      date_range: this.state.datesRange,
      sorted: req.sorted ? req.sorted : this.state.sorted,
      filtered: req.filtered ? req.filtered : this.state.filtered,
      export: 1
    };
    return request.download(this, this.state.apiEndpoint, payload).then(resp => {
      this.setState({ isLoading: false });
    });
  };

  handleReport = () => {
    this.setState({
      page: 0,
      pages: -1,
      sorted: [],
      filtered: [],
      data: [],
      columns: [],
      pageJump: false
    }, () => this.fetchData());
  }

  render() {
    const { isLoading, data, columns, pageSize, pages, page } = this.state;
    return (
      <Segment basic>
        <PageHeader
          title={this.props.route.title}
          breadcrumbs={{
            key: "active",
            content: this.props.route.title,
            active: true
          }}
        />
        <ReportFilters
          currentState={this.state}
          change={this.handleChange}
          fetch={this.handleReport}
          download={this.fetchExport}
        />

        {this.state.error ?
          (<div
            style={{
              backgroundColor: '#f8d7da',
              color: '#721c24',
              padding: '10px',
              borderRadius: '4px',
              marginBottom: '10px',
              border: '1px solid #f5c6cb'
            }}
            className="error"
          >
            {this.state.error}
          </div>) :
          <ReactTable
          manual
          data={data}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it
          resizable={true}
          filterable={false}
          defaultPageSize={20}
          defaultSorted={[{ id: "name", desc: false }]}
          pageSize={pageSize}
          sorted={this.state.sorted}
          resized={this.state.resized}
          minRows={0}
          pages={pages}
          page={page}
          showPagination={pages > 0 ? true : false}
          // Callbacks

          onSortedChange={sorted => this.setState({ sorted }, () => this.fetchData())}

          onPageChange={page => this.setState({ page }, () => this.fetchData())}
          onPageSizeChange={
            (pageSize, page ) => {
                this.setState({ page, pageSize }, () => this.fetchData())
            }
          }




          SubComponent={row => {
            if (row.original.sales) {
              return (
                  <div>
                      <div style={{ padding: "20px" }}>
                          <ReactTable
                              data={row.original.sales}
                              columns={salesBreakdown}
                              minRows={0}
                              resizable={false}
                              defaultPageSize={pageSize}
                              showPagination={false}
                          />
                      </div>
                      <div style={{ padding: "20px" }}>
                          <ReactTable
                              data={row.original.time_frames}
                              columns={locationSalesBreakdown}
                              minRows={0}
                              resizable={false}
                              defaultPageSize={pageSize}
                              showPagination={false}
                          />
                      </div>
                  </div>
              );
          }


            if (row.original.CustomerData) {
              if (row.original.CustomerData === null) row.original.CustomerData = [];
              return (
                <div style={{ padding: "20px" }}>
                  <ReactTable
                    data={row.original.CustomerData}
                    columns={CustomerData}
                    minRows={0}
                    resizable={false}
                    defaultPageSize={pageSize}
                    showPagination={false}
                  />
                </div>
              );
            }
            if (row.original.volunteer_breakdown) {
              if (row.original.volunteerBreakdownColumn === null) row.original.volunteerBreakdownColumn = [];
              return (
                <div style={{ padding: "20px" }}>
                  <ReactTable
                    data={row.original.volunteer_breakdown}
                    columns={volunteerBreakdownColumn}
                    minRows={0}
                    resizable={false}
                    defaultPageSize={pageSize}
                    showPagination={false}
                  />
                </div>
              );
            }
            return false;
          }}
        />
        }
      </Segment>
    );
  }
}

export default Report;
